import type {GroupBase, SingleValueProps} from "react-select";
import {components} from "react-select";

import {HStack} from "../ui/hstack";
import {Text} from "../ui/text";

import type {OptionType} from "./Select";

export function SingleValue<
    Option extends OptionType,
    IsMulti extends boolean,
    Group extends GroupBase<Option>
>({children, ...props}: SingleValueProps<Option, IsMulti, Group>) {
    const {data} = props;
    return (
        <components.SingleValue {...props}>
            <HStack className="items-center" space="xs">
                {data.leftIcon}
                {data.prefix}
                <Text isTruncated color="blueGray.800" testID="selected-value" variant="sm">
                    {children}
                </Text>
                {data.suffix}
                {data.Icon}
            </HStack>
        </components.SingleValue>
    );
}
